import {
  Button,
  CircularProgress,
  CssBaseline,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormHelperText,
  Grid,
  Snackbar,
  TextField,
  useTheme,
  useMediaQuery,
  Tooltip,
  FormControl,
  Typography,
  Switch
} from "@mui/material";
import { Alert } from "@mui/lab";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import CommonBackDrop from "../common/BackDrop/CommonBackDrop";
import AttachFileIcon from "@mui/icons-material/AttachFileRounded";
import _ from "lodash/fp";
import ClearIcon from "@mui/icons-material/Clear";
import SaveIcon from "@mui/icons-material/Save";
import { CommonService } from "../../services";
import useStyles from "../common/CommonStyle/CommonStyle";
import { FormattedMessage, useIntl } from "react-intl";
import Fab from "@mui/material/Fab";
import { GlobalEdiApiConstants } from "../../Constants/GlobalEdiApiConstants";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { useHistory } from "react-router-dom";
import saveAs from "file-saver";
import ExcelIcon from "../../components/CustomsValuation/ExcelIcon.svg";
import { Box } from "@mui/material";

const FileUploadSection = props => {
  const classes = useStyles();
  const theme = useTheme();
  const history = useHistory();

  const intl = useIntl();

  // const { onClose, open, isFileUpload, dialogHeader, isPartchange, selectedRow, isBusinessPartnerPortal, refreshAddOrView, setRefreshAddOrView } = props;
  const {
    onClose,
    open,
    isFileUpload,
    dialogHeader,
    isBusinessPartnerPortal,
    defaultEntity,
    defaultBpType,
    isPartchange,
    refreshAddOrView,
    setRefreshAddOrView
  } = props;
  const currentUser = CommonService.getLoggedInUserInfo();
  const apiUrlAndParamBodyConstants = GlobalEdiApiConstants();
  const mobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const [uploadedUserTypeUpdate, setUploadedUserTypeUpdate] = useState(
    currentUser.userType === "SIIX-USER" ? false : true
  );
  const [selectedRows, setSelectedRows] = useState([]);
  const [templateNameList, setTemplateNameList] = useState("");
  const pageLabelsNamesAndConst = {
    labels: {
      dialogTitle: "Upload File",
      attachButton: "Attach",
      cancel: "Cancel",
      submitButton: "Submit",
      uploadFile: "File"
    },
    name: {
      uploadFile: "uploadedFile",
      importTmplName: "importTmplName"
    }
  };

  const {
    handleSubmit,
    control,
    formState: { errors }
  } = useForm({
    mode: "all",
    defaultValues: {}
  });

  const [state, setState] = React.useState({
    openAlert: false,
    vertical: "top",
    horizontal: "center",
    message: "",
    severity: ""
  });

  const SelectedFileList = ({ selectedFileName }) => {
    return (
      <List>
        <ListItem>
          <ListItemText primary={selectedFileName} />
        </ListItem>
      </List>
    );
  };

  const { vertical, horizontal, openAlert, message, severity } = state;

  let defaultEntityName =
    currentUser.userEntityAccessList !== null
      ? currentUser.userEntityAccessList.filter(item => {
          return item.defaultEntity === true;
        })
      : [];

  const [refreshTable, setRefreshTable] = useState(false);

  const [impTmplHeaderColumns, setImpTmplHeaderColumns] = useState([]);

  const [selectedFileName, setSelectedFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState("");
  const [isResponseArrived, setResponseArrived] = useState(false);
  const [importTmplNameValue, setImportTmplNameValue] = useState("");
  const [openBackDrop, setOpenBackDrop] = useState(false);
  const closeCreateOrEditViewDialog = confirmed => {
    if (confirmed) {
      setAlertBoxState({
        ...alertBoxState,
        openAlert: true,
        message: (
          <FormattedMessage
            id="snackbar.recordupdatedsuccessfullypermission"
            defaultMessage="Record updated successfully"
          />
        ),
        severity: "success"
      });
      setRefreshTable(!refreshTable);
    }
  };
  const onError = errors => {
    setAlertBoxState({
      ...alertBoxState,
      openAlert: true,
      message: "Form Has Errors",
      severity: "error",
      err: true
    });
  };
  const pageLabelsConstantsAndMessages = {
    labels: {
      dialogTitle: "Upload File",
      attachButton: "Attach",
      cancel: "Cancel",
      submitButton: "Submit",
      uploadFile: "File"
    },
    name: {
      uploadFile: "uploadedFile",
      importTmplName: "importTmplName"
    }
  };

  const handleClose = value => {
    onClose(value);
    setSelectedFileName("");
    setSelectedFile("");
  };

  const [paramBodyForDefaultImpTemp, setParamBodyForDefaultImpTemp] = useState(
    apiUrlAndParamBodyConstants.paramBodyForGetListApis.importTemplate
  );

  const [branchValue, setBranchValue] = useState({
    entityName: defaultEntityName[0].entity.entityName,
    erpEntityCode: defaultEntity,
    valuesToBeDisplayed: `${defaultEntity} - ${defaultEntityName[0].entity.entityName}`,
    earlierAcceptanceDays: defaultEntityName[0].entity.earlierAcceptanceDays,
    lateAcceptanceDays: defaultEntityName[0].entity.lateAcceptanceDays
  });

  useEffect(() => {
    if (
      templateNameList.length === 0 &&
      importTmplNameValue.name === "SO-Customs Valuation-Template"
    ) {
      setParamBodyForDefaultImpTemp({
        ...paramBodyForDefaultImpTemp,
        body: {
          importTmplName: importTmplNameValue.name,
          entity: {
            erpEntityCode:
              branchValue !== undefined ? branchValue.erpEntityCode : ""
          },
          bpCode: "All Supplier BP Code"
        },
        sortDir: "asc",
        sortKey: "importTmplName",
        recordsPerPage: 100
      });
    }
  }, [templateNameList, importTmplNameValue]);

  useEffect(() => {
    if (
      (templateNameList !== "" || templateNameList.length !== 0) &&
      importTmplNameValue !== ""
    ) {
      let headerColumns = templateNameList
        .filter(item => {
          return item.importTmplName === importTmplNameValue.name;
        })
        .map(col => col.headerColumns);
      if (headerColumns[0] !== undefined) {
        setImpTmplHeaderColumns(
          headerColumns[0].map(col => {
            return { headerName: col.headerName };
          })
        );
      }
    }
  }, [templateNameList, importTmplNameValue]);
  const [alertBoxState, setAlertBoxState] = React.useState({
    openAlert: false,
    vertical: "top",
    horizontal: "center",
    message: "",
    severity: ""
  });

  const handleCloseAlert = () => {
    setAlertBoxState({ ...state, openAlert: false });
  };

  const onSubmit = data => {
    console.log("file submitted");
    data["fileName"] = data.fileName;

    if (selectedFile !== "") {
      const formData = new FormData();
      formData.append("bpType", "SUPPLIER");
      formData.append("bpCode", "All Supplier BP Code");
      formData.append("importTmplId", "39");
      formData.append("importTmplName", "SO-CUSTOMS VALUATION");
      formData.append("entity", "SO");
      formData.append("bpName", "Customs Valuation");
      formData.append(
        "uploadedUserType",
        uploadedUserTypeUpdate === false
          ? 0
          : currentUser.userType === "SIIX-USER"
          ? 1
          : 2
      );
      formData.append("moduleName", "Customs_valuation");
      formData.append("uploadedFile", selectedFile);
      formData.append("fileName", selectedFileName);
      // formData.append('documentUpload', JSON.stringify({
      //   processMaster: {
      //     processId: 42,
      //   },
      //   primaryNumber: 400,
      //   process: "Customs Valuation",
      //   orgCode: "SIIXCORP",
      //   entityCode: "SO"
      // }));
      console.log("formData", formData);
      setOpenBackDrop(true);
      console.log("Submitting FormData to API...");
      CommonService.uploadFileForDataImport("/importDataFile", formData)
      .then(response => {
        setAlertBoxState({
          ...alertBoxState,
          openAlert: true,
          message: (
            <FormattedMessage id="snackbar.recordupdatedsuccessfullypermission" />
          ),
          severity: "success"
        });
        setResponseArrived(false);
        setState({ ...state, openAlert: true, message: <FormattedMessage id="yourrequestnoforimport.snackbar.text" values={{ responsedata: `${response.data.value}` }} />, severity: "success" });
        setOpenBackDrop(false);
        onClose(true);
        setSelectedFileName("");
        setRefreshAddOrView(!refreshAddOrView);
      });

      console.log("success");
    }
  };

  const handleDrop = event => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) {
      setSelectedFileName(file.name);
      setSelectedFile(file);
    }
  };

  const handleDragOver = event => {
    event.preventDefault();
  };

  return (
    <React.Fragment>
      <CssBaseline />
      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={openAlert}
        onClose={handleCloseAlert}
        key={vertical + horizontal}
        autoHideDuration={9000}
      >
        <Alert onClose={handleCloseAlert} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
      <CommonBackDrop open={openBackDrop} />
      {/* <ConfirmationDialog onClose={closeConfirmationDialog} 
   message={confirmationMessage}  open={openConfirmationDialog} 
          /> */}
      <Dialog
        fullWidth
        aria-labelledby="create-or-delete-dialog"
        maxWidth="sm"
        open={open}
      >
        <DialogTitle color="primary" className={classes.title}>
          <Grid container>
            <Grid
              container
              justifyContent="flex-start"
              alignItems="center"
              item
              xs={12}
              sm={12}
              md={8}
              lg={8}
            >
              <strong>
                {dialogHeader !== undefined ? (
                  dialogHeader
                ) : (
                  <FormattedMessage
                    id="dialogtitle.uploadfile"
                    defaultMessage="Upload Delivery Confirmation Schedule"
                  />
                )}
              </strong>
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent dividers style={{ minHeight: "100px" }}>
          <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              spacing={2}
            >
              <Grid item container xs={12} sm={12} md={12} lg={12} spacing={2}>
                <Grid item container xs={12}>
                  <Grid
                    item
                    container
                    xs={12}
                    sm={12}
                    md={12}
                    lg={12}
                    spacing={2}
                  >
                    <Grid
                      item
                      container
                      xs={10}
                      sm={11}
                      md={11}
                      lg={11}
                      onDrop={handleDrop}
                      onDragOver={handleDragOver}
                      style={{
                        border: "2px dotted #ccc",
                        padding: "20px",
                        borderRadius: "10px",
                        textAlign: "center",
                        backgroundColor: "#f9f9f9",
                        cursor: "pointer",
                        marginTop: "25px",
                        marginLeft: "30px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "flex-start"
                      }}
                    >
                      <TextField
                        className={classes.uploadTextField}
                        size="small"
                        margin="normal"
                        variant="outlined"
                        value={selectedFileName}
                        InputLabelProps={{
                          shrink: true,
                          classes: {
                            asterisk: classes.asterisk
                          }
                        }}
                        InputProps={{
                          inputProps: {
                            style: {
                              textAlign: "center"
                            }
                          }
                        }}
                        placeholder="Drag and drop a file here or click the icon"
                        fullWidth
                      />
                      <div style={{ marginTop: "10px" }}>
                        <label htmlFor="contained-button-file">
                          <Fab size="small" color="primary" component="span">
                            <AttachFileIcon />
                          </Fab>
                        </label>
                        <input
                          accept={
                            importTmplNameValue.fileType === "EXCEL_2003"
                              ? ".xls"
                              : importTmplNameValue.fileType === "EXCEL"
                              ? ".xlsx"
                              : importTmplNameValue.fileType === "TXT"
                              ? ".txt"
                              : importTmplNameValue.fileType === "CSV"
                              ? ".csv"
                              : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          }
                          className={classes.input}
                          id="contained-button-file"
                          name={pageLabelsConstantsAndMessages.name.sftpPrvKey}
                          type="file"
                          onChange={event => {
                            event.preventDefault();
                            if (event.target.files[0]) {
                              setSelectedFileName(event.target.files[0].name);
                              setSelectedFile(event.target.files[0]);
                            }
                          }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </form>
        </DialogContent>
        {!mobileScreen && (
          <DialogActions className={classes.dialogActionForFileUploading}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Button
                size="small"
                variant="contained"
                color="secondary"
                className={classes.buttonSpacing}
                startIcon={<ClearIcon />}
                onClick={() => {
                  handleClose(false);
                }}
              >
                <FormattedMessage
                  id="common.button.cancel.lable"
                  defaultMessage={pageLabelsNamesAndConst.labels.cancel}
                />
              </Button>
              <Button
                type="submit"
                size="small"
                variant="contained"
                color="primary"
                className={classes.buttonSpacing}
                onClick={handleSubmit(onSubmit)}
                disabled={
                  isResponseArrived ||
                  selectedFile === undefined ||
                  selectedFile === "" ||
                  selectedFileName === ""
                }
                startIcon={<SaveIcon />}
                endIcon={
                  isResponseArrived ? (
                    <CircularProgress color="secondary" size={20} />
                  ) : null
                }
              >
                <FormattedMessage
                  id="common.button.submit.lable"
                  defaultMessage={pageLabelsNamesAndConst.labels.submitButton}
                />
              </Button>
            </Grid>
          </DialogActions>
        )}
        {mobileScreen && (
          <DialogActions className={classes.dialogActionForFileUploading}>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
            >
              <Tooltip
                title={<FormattedMessage id="common.button.cancel.lable" />}
              >
                <Button
                  size="small"
                  variant="contained"
                  color="secondary"
                  className={classes.buttonSpacing}
                  onClick={() => {
                    handleClose(false);
                  }}
                >
                  <ClearIcon />
                </Button>
              </Tooltip>
              <Tooltip
                title={<FormattedMessage id="common.button.submit.lable" />}
              >
                <Button
                  type="submit"
                  size="small"
                  variant="contained"
                  color="primary"
                  className={classes.buttonSpacing}
                  onClick={handleSubmit(onSubmit, onError)}
                  disabled={
                    isResponseArrived ||
                    selectedFile === undefined ||
                    selectedFile === "" ||
                    selectedFileName === ""
                  }
                  endIcon={
                    isResponseArrived ? (
                      <CircularProgress color="secondary" size={20} />
                    ) : null
                  }
                >
                  <SaveIcon />
                </Button>
              </Tooltip>
            </Grid>
          </DialogActions>
        )}
      </Dialog>
    </React.Fragment>
  );
};

export default FileUploadSection;
